<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
  (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'parametros.estoqueAMP.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'parametros.estoqueAMP.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </header>
        <div class="container-fluid">
          <div class="row">
            <div class="col col-lg-12">
              <small translate class="text-info">{{'parametros.estoqueAMP.cadastro.CampoObrigatorio'}}</small>
              <hr />
            </div>
          </div>
          <div class="row" *ngIf="!carregando">
            <!-- <app-text-box [state]="state" class="col-lg-2"
              label="{{'parametros.estoqueAMP.cadastro.dadosPrincipais.idEstoqueAMP' | translate}}" name="idEstoqueAMP"
              [(ngModel)]="model.id"
              placeholder="{{'parametros.estoqueAMP.cadastro.dadosPrincipais.idEstoqueAMPPlaceHolder' | translate}}"
              [ativo]="false">
            </app-text-box> -->

            <div class="div-check">
              <input id="check" type="checkbox" [checked]="todos" (change)="todosdelaer()" />
              <label translate class="label-check" for="check">{{'parametros.estoqueAMP.cadastro.dadosPrincipais.todosOsDealers'}}</label>
            </div>
          </div>

          <div class="row">
            <app-dropdown-list-api [state]="state" class="col-md-6 col-lg-5" *ngIf="todos == false" label="Dealer"
              name="dealer" [(ngModel)]="model.id_dealer" obrigatorio="true" required filtro="dealer">
            </app-dropdown-list-api>


          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-5"
              label="{{'parametros.estoqueAMP.cadastro.dadosPrincipais.partNumber' | translate}}" name="partNumber"
              [(ngModel)]="model.partNumber" obrigatorio="true" required
              placeholder="{{'parametros.estoqueAMP.cadastro.dadosPrincipais.partNumberPlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box [state]="state" class="col-lg-5"
              label="{{'parametros.estoqueAMP.cadastro.dadosPrincipais.quantidade' | translate}}"
              name="quantidade_partnumber" [(ngModel)]="model.quantidade" obrigatorio="true" required
              placeholder="0...">
            </app-text-box>
          </div>
          <hr />
          <div class="jumbotron">
            <div class="row">
              <div class="col-10">
                <legend translate>{{'parametros.estoqueAMP.cadastro.dadosPrincipais.legenda1'}}</legend>
                <legend translate>{{'parametros.estoqueAMP.cadastro.dadosPrincipais.legenda2'}}</legend>
                <legend translate>{{'parametros.estoqueAMP.cadastro.dadosPrincipais.legenda3'}}</legend>
                <legend translate>{{'parametros.estoqueAMP.cadastro.dadosPrincipais.legenda4'}}</legend>
              </div>
              <div class="col-2">
                <div class="float-right mr-4">
                  <a class="btn download" href="assets/modelos/modelo-estoque-amp.xlsx">
                    <i class="fas fa-file-download"></i>
                  </a>
                  {{'parametros.estoqueAMP.cadastro.dadosPrincipais.modelo' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="state == 1">
            <div class="col col-lg-12">
              <p translate class="text-info">{{'parametros.estoqueAMP.cadastro.dadosPrincipais.adicionarArquivoXlsCadastro'}}</p>
              <p-fileUpload mode="advanced" fileLimit="1" name="myfile[]" customUpload="true" accept=".xlsx"
                (uploadHandler)="Uploader($event)"></p-fileUpload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>